<template>
  <div>
    <h3 v-if="onAddingProcess" class="py-4">Add New Tenant</h3>
    <div>
      <v-btn
        v-if="!onAddingProcess"
        @click="addNewTenant"
        style="margin-right: 65px"
        fixed
        right
        bottom
        fab
        medium
        dark
        color="accent">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn
        v-else
        @click="
          onAddingProcess = false;
          selectedTenant = tenants[0].id;
          getTenantDetail();
        "
        style="margin-right: 65px"
        fixed
        right
        bottom
        fab
        medium
        dark
        color="red">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="my-2" @click="saveTenant()">
      <v-btn color="greeny" fixed right bottom fab medium dark>
        <v-icon>mdi-content-save-outline</v-icon>
      </v-btn>
    </div>

    <!--<FloatButtons @add="addNewTenant" />-->

    <!--TENANT SELECT FOR FETCHING DATA-->
    <v-select
      v-if="!onAddingProcess"
      label="Tenant"
      :items="tenants"
      v-model="selectedTenant"
      @change="getTenantDetail"
      item-text="name"
      item-value="id"
      solo
      required></v-select>

    <div>
      <!--WE COLLECT GENERAL SINGLE FORM INFORMATIONS UNDER INFORMATION COLLAPSE-->
      <InformationCollapse
        :onAddingProcess="onAddingProcess"
        :tenant="data"
        :currencies="currencies"
        :locales="locales"
        :bookingSystems="bookingSystems"
        :paymentSystems="paymentSystems" />
      <!--TORA CREDENTIALS TABLE-->
      <ToraCredentials :tenant="data" :onAddingProcess="onAddingProcess" />
      <!--SILVERRAIL CREDENTIALS TABLE-->
      <SilverrailCredentials
        :onAddingProcess="onAddingProcess"
        :loading="dataLoader"
        :data="data.silverrailCredentials" />
      <!--SHIPPING CREDENTIALS TABLE-->
      <ShippingCredentials :tenant="data" :onAddingProcess="onAddingProcess" />
      <!--TAXI CREDENTIALS TABLE-->
      <TaxiCredentials :tenant="data" :onAddingProcess="onAddingProcess" />
      <!--KLARNA CREDENTIALS TABLE-->
      <KlarnaCredentials :onAddingProcess="onAddingProcess" :loading="dataLoader" :data="data.klarnaCredentials" />
      <!--SWISH CREDENTIALS TABLE-->
      <SwishCredentials :tenant="data" :onAddingProcess="onAddingProcess" />
      <!--SYSTEM OBJECTS-->
      <SystemObjects
        :onAddingProcess="onAddingProcess"
        :loading="dataLoader"
        :data="data.systems"
        :systemObjects="systemObjects" />
      <!--BANNERS-->
      <Banners :tenant="data" :locales="locales" :onAddingProcess="onAddingProcess" />
      <!--ACCOUNTING SALES UNIT NUMBERS-->
      <AccountingSalesUnitNumbers :data="data.accountingSalesUnitNumbers" :currencies="currencies" />
      <!--TRAVELER CATEGORIES-->
      <TravelerCategories :data="data.travelerCategorySettings" :locales="locales" />
    </div>
  </div>
</template>

<script>
import { getErrorMessage } from "@/util/helpers";
import Header from "@/components/common/Header.vue";
import common from "@/mixins/common";
import InformationCollapse from "@/views/TenantManagement/components/InformationCollapse";
import KlarnaCredentials from "@/views/TenantManagement/components/KlarnaCredentials";
import SwishCredentials from "@/views/TenantManagement/components/SwishCredentials";
import SilverrailCredentials from "@/views/TenantManagement/components/SilverrailCredentials";
import AccountingSalesUnitNumbers from "@/views/TenantManagement/components/AccountingSalesUnitNumbers";
import TravelerCategories, {
  buildTravelerCategoryPayload,
} from "@/views/TenantManagement/components/TravelerCategories";
import ToraCredentials from "@/views/TenantManagement/components/ToraCredentials";
import ShippingCredentials from "@/views/TenantManagement/components/ShippingCredentials";
import TaxiCredentials from "@/views/TenantManagement/components/TaxiCredentials";
import SystemObjects from "@/views/TenantManagement/components/SystemObjects";
import Banners from "@/views/TenantManagement/components/Banners";
import { mapGetters } from "vuex";
import FloatButtons from "./components/FloatButtons.vue";

const initialData = {
  id: "00000000-0000-0000-0000-000000000000",
  name: "New Tenant",
  bookingAffiliateId: null,
  isOwnedByTrainPlanet: false,
  canSellCancellationProtection: false,
  canSellJourneys: false,
  canSellRailPassSeatReservations: false,
  canSellRailPasses: false,
  canSellTaxis: false,
  canUseGiftCards: false,
  canSellTicketsByInvoice: false,
  nationalIdNumberVerificationRequired: false,
  useMainTenantsNameForToSInEPSPayload: false,
  showNewsletterCheckboxInCheckout: false,
  useCustomConsent: true,
  isTora: false,
  sendPaymentReminderEmails: true,
  showTaxiInCheckout: false,
  allowedBookingSystems: [],
  allowedPaymentSystems: [],

  emailCredentials: {
    fromAddress: "",
    fromName: "",
    host: "",
    port: 0,
    username: "",
  },
  klarnaCredentials: [],
  swishCredentials: [],
  silverrailCredentials: [],
  accountingSalesUnitNumbers: [],
  travelerCategorySettings: [],
  toraCredentials: [],
  shippingCredentials: [],
  taxiCredentials: [],
  theme: {
    mainColor: "#494968",
    secondaryColor: "#DB6484",
    headerColor: "#494968",
    headerTitleColor: "#FFFFFF",
    titleColor: "#FFFFFF",
    titleBackgroundColor: "#494968",
    darkColor: "#35323d",
    positiveColor: "#06bd58",
    negativeColor: "#f84239",
    headerBackgroundColor: "#35372",
    navBarBackgroundColor: "#494968",
    appBackgroundColor: "#f9f7f7",
    mutedColor: "#AEABB5",
    borderColor: "#EAEAEA",
    fontFamily: "Poppins, sans-serif",
    genericLetterSpacing: "normal",
    mainColorSvgFilters: "invert(42%) sepia(79%) saturate(5881%) hue-rotate(346deg) brightness(92%) contrast(99%);",
    secondaryColorSvgFilters:
      "invert(42%) sepia(79%) saturate(5881%) hue-rotate(346deg) brightness(92%) contrast(99%);",
    mainPageUrl: "trainplanet.com",
    shopUrl: "tickets.trainplanet.com",
    logoUrl: "https://assets.trainplanet.com/logos/trainplanet-black.png",
    logoPngUrl: "https://assets.trainplanet.com/email-resources/trainplanet.png",
    blackLogoUrl: "https://assets.trainplanet.com/logos/trainplanet-black.png",
    footerLogoUrl: "https://assets.trainplanet.com/logos/trainplanet-black.png",
    poweredByLogoUrl: "https://assets.trainplanet.com/email-resources/poweredby-white-header.png",
    giftCardBackgroundImageUrl: "https://assets.trainplanet.com/components/giftcards/gift-card.jpg",
    customerPageBackgroundUrl: null,
    supportNumber: "0771 - 75 75 70",
    supportEmail: "support@trainplanet.com",
    customerPageUrl: "https://customer.trainplanet.com",
    termsAndConditionsPageUrl: "https://trainplanet.com/en/terms-and-conditions",
    accessibilityUrl: null,
    searchUrl: null,
    logoWidth: "220px",
    loadingAnimationUrl: "https://assets.trainplanet.com/wlabel/trainplanet/animations/loading.gif",
    gtmId: "GTM-0000000",

    supportPageUrls: [
      {
        locale: "sv-SE",
        url: "",
      },
    ],
    trafficPageUrls: [],
    groupOrderLinks: [
      {
        locale: "sv-SE",
        url: "",
      },
    ],
    navigationMenu: [
      {
        locale: "sv-SE",
        items: [],
      },
    ],
    languages: ["sv-SE"],
    currencies: ["SEK"],
    showCurrencyPicker: true,
    showPeriodCardToggle: true,
    showTrainVacationCardToggle: false,
    showInterrailToggle: true,
    showPromoCodeInputField: false,
    preferOutline: false,
    favoriteDestinations: [
      {
        id: "urn:x_swe:stn:740000001",
        name: "Stockholm Centralstation",
        countryCodeUIC: 74,
      },
      {
        id: "urn:x_swe:stn:740000002",
        name: "Göteborg Centralstation",
        countryCodeUIC: 74,
      },
      {
        id: "urn:x_swe:stn:740000003",
        name: "Malmö Centralstation",
        countryCodeUIC: 74,
      },
      {
        id: "urn:x_swe:stn:740000130",
        name: "Sundsvall Centralstation",
        countryCodeUIC: 74,
      },
      {
        id: "urn:x_swe:stn:740000190",
        name: "Umeå Centralstation",
        countryCodeUIC: 74,
      },
    ],
    defaultTransportModes: [],
    showNavigationMenu: true,
    toolbarOptions: {
      enabled: true,
      showContactButton: false,
      showCustomerPageButton: false,
      showFunkaButton: false,
      showMailButton: false,
      showPhoneButton: false,
      showSearchButton: false,
    },
    accentColor: "#9c27b0",
    infoColor: "#31ccec",
    warningColor: "#f2c037",
    travelModeBackgroundColor: "#494968",
    travelModeBackgroundOpacity: 60,
    selectedTravelModeTabBackgroundColor: "#DB6484",
    toolbarBackgroundColor: "#535372",
    sectionHeaderBackgroundColor: "#494968",
    actionColor: "#DB6484",
    genericIconColor: "#DB6484",
    genericBorderRadius: "8px",
    mainActionButtonRadius: "8px",
    outlinedFieldColor: null,
    plainCodeFields: false,
    borderBottomOnHeader: false,
    showFaqButton: false,
    showJourneyOverviewIcons: false,
    generalIcons: {
      info: {
        name: "mdi:information-outline",
        isCustom: false,
      },
    },
    searchEngineIcons: {
      singleTickets: {
        name: "tabler:ticket",
        isCustom: false,
        color: "#494968",
      },
      periodTickets: {
        name: "lucide:calendar-clock",
        isCustom: false,
        color: "#494968",
      },
      oneWay: {
        name: "charm:arrow-right",
        isCustom: false,
        color: "#494968",
      },
      withReturn: {
        name: "charm:swap-horizontal",
        isCustom: false,
        color: "#494968",
      },
      swap: {
        name: "charm:swap-horizontal",
        isCustom: false,
        color: "#494968",
      },
      from: {
        name: "mingcute:send-fill",
        isCustom: false,
        color: "#494968",
      },
      to: {
        name: "material-symbols:location-on-rounded",
        isCustom: false,
        color: "#494968",
      },
      datepicker: {
        name: "mingcute:calendar-line",
        isCustom: false,
        color: "#494968",
      },
      datepickerOutboundTime: {
        name: "mingcute:arrow-right-up-fill",
        isCustom: false,
        color: "#DB6484",
      },
      datepickerInboundTime: {
        name: "mingcute:arrow-right-down-fill",
        isCustom: false,
        color: "#DB6484",
      },
      passengerPicker: {
        name: "passengers",
        isCustom: true,
        color: "#494968",
      },
    },
    timetableIcons: {
      duration: {
        name: "mingcute:time-duration-line",
        isCustom: false,
      },
      changes: {
        name: "tabler:status-change",
        isCustom: false,
      },
      transport: {
        name: "mdi:train-bus",
        isCustom: false,
      },
      operators: {
        name: "game-icons:captain-hat-profile",
        isCustom: false,
      },
      seat: {
        name: "mdi:seat",
        isCustom: false,
      },
      couchette: {
        name: "mdi:bed",
        isCustom: false,
      },
      berth: {
        name: "mdi:bed",
        isCustom: false,
      },
    },
    passengerIcons: {
      adult: {
        name: "mingcute:user-3-fill",
        isCustom: false,
      },
      childYouth: {
        name: "material-symbols:account-child-invert",
        isCustom: false,
      },
      student: {
        name: "mdi:school",
        isCustom: false,
      },
      retired: {
        name: "mingcute:user-3-fill",
        isCustom: false,
      },
      senior: {
        name: "mingcute:user-3-fill",
        isCustom: false,
      },
    },
    toolbarIcons: {
      supportNumber: {
        name: "ion:call",
        isCustom: false,
      },
      supportEmail: {
        name: "ic:outline-mail",
        isCustom: false,
      },
      funka: {
        name: "ion:volume-high",
        isCustom: false,
      },
      search: {
        name: "ion:search",
        isCustom: false,
      },
      contact: {
        name: "material-symbols:support",
        isCustom: false,
      },
      user: {
        name: "mingcute:user-3-fill",
        isCustom: false,
      },
    },
    widgetSettings: {
      tabBackgroundOpacity: 60,
      searchBarBackgroundColor: "#f5f5f5",
      promoCodesBackgroundColor: null,
      darkInterrailToggle: false,
      layoutMode: "auto",
      showSearchBarBackground: true,
    },
    domains: [],
    showCorporateAgreementsCodeInputField: false,
  },
  systems: [],
  banners: [],
};

export default {
  mixins: [common],
  components: {
    Header,
    FloatButtons,
    SilverrailCredentials,
    AccountingSalesUnitNumbers,
    TravelerCategories,
    ToraCredentials,
    KlarnaCredentials,
    SwishCredentials,
    InformationCollapse,
    SystemObjects,
    ShippingCredentials,
    TaxiCredentials,
    Banners,
  },
  data: () => ({
    onAddingProcess: false,
    selectedTenant: "",
    systemObjects: [],
    data: initialData,
    dataLoader: false,
    currencies: [],
    locales: [],
    bookingSystems: [],
    paymentSystems: [],
  }),
  async mounted() {
    this.loading = true;

    await Promise.all([this.getCurrenciesAndLocales(), this.getSystemObjects()]);

    this.loading = false;
  },
  watch: {
    tenants(val) {
      if (val.length > 0) {
        this.selectedTenant = this.tenants[0].id;
        this.getTenantDetail();
      }
    },
  },
  computed: {
    ...mapGetters({
      tenants: "auth/userTenants",
    }),
  },
  methods: {
    addNewTenant() {
      this.onAddingProcess = true;
      this.selectedTenant = "";
      this.data = initialData;
    },
    prepareTenantDataForEditing() {
      if (!this.data.accountingSalesUnitNumbers) {
        this.data.accountingSalesUnitNumbers = [];
      }

      // A tenant that has never been configured comes back without the key at all, and Vue 2 cannot
      // bind the rows to one that is not on the object yet.
      if (!Array.isArray(this.data.travelerCategorySettings)) {
        this.$set(this.data, "travelerCategorySettings", []);
      }
    },
    async getTenantDetail() {
      this.dataLoader = true;
      try {
        this.data = await this.api.getTenantDetail(this.selectedTenant);
        this.prepareTenantDataForEditing();
      } catch (error) {
        await this.$store.dispatch("error", getErrorMessage(error));
      }
      this.dataLoader = false;
    },
    async getSystemObjects() {
      try {
        this.systemObjects = await this.api.getSystemObjects();
      } catch (error) {
        this.onError(getErrorMessage(error));
      }
    },
    async saveTenant() {
      this.pageLoader(true);
      try {
        const { payload: travelerCategorySettings, error: travelerCategoryError } = buildTravelerCategoryPayload(
          this.data.travelerCategorySettings
        );

        if (travelerCategoryError) {
          this.onError(travelerCategoryError);
          this.pageLoader(false);
          return;
        }

        let res;
        const payload = {
          ...this.data,
          accountingSalesUnitNumbers: (this.data.accountingSalesUnitNumbers || []).filter(
            (item) => item.currency && item.salesUnitNumber
          ),
          travelerCategorySettings,
        };
        if (this.onAddingProcess) {
          res = await this.api.saveNewTenant(payload);
          this.onAddingProcess = false;
        } else {
          res = await this.api.updateTenant(payload);
        }
        this.data = res;
        this.prepareTenantDataForEditing();
        this.onSuccess("You have successfully saved the tenant.");
      } catch (error) {
        this.onError(getErrorMessage(error));
      }
      this.pageLoader(false);
    },
    async getCurrenciesAndLocales() {
      const options = await this.api.getOrderSystemOptions();

      this.currencies = Object.keys(options.currencies);
      this.locales = Object.entries(options.locales).map(([value, text]) => ({
        value,
        text,
      }));
      this.bookingSystems = options.EBS || [];
      this.paymentSystems = options.EPS || [];
    },
  },
};
</script>

<style lang="scss">
.on-add {
  border: 3px solid #d0edda;
}
</style>
